import {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { Scenario } from "@/types/scenario";
import DeleteIcon from "@/assets/images/delete-pink.svg";
import CommonImg from "@/components/Common/Img";
import { useParams } from "react-router-dom";
import { useDeleteProjectGroupsScenariosById } from "@/libs/react-query/hooks/useScenarioQuery";
import { showToast } from "@/utils/toastUtils";
import { Button } from "@/components/ui/button";

type Props = {
  scenario: Scenario;
};

export default function DeleteScenarioDialog({ scenario }: Props) {
  const { group_id = "" } = useParams();

  const { mutateAsync: deleteScenario } = useDeleteProjectGroupsScenariosById(
    group_id,
    scenario.scenario_id
  );

  const handleDelete = async () => {
    await deleteScenario();

    showToast({
      message: "시나리오가 삭제되었습니다.",
      type: "success",
    });
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button className="text-pink px-5 py-2 flex gap-1 hover:bg-gray-E">
          <CommonImg src={DeleteIcon} alt="D" className="w-3 h-3" />
          시나리오 삭제
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent className="h-[222px] flex flex-col">
        <AlertDialogHeader className="flex-1">
          <AlertDialogTitle>시나리오 삭제</AlertDialogTitle>
          <AlertDialogDescription />
        </AlertDialogHeader>
        <div className="flex items-center justify-center flex-1">
          <span className="text-lg text-[#000] font-normal">
            해당 시나리오를 삭제하시겠습니까?
          </span>
        </div>
        <AlertDialogFooter>
          <AlertDialogAction asChild>
            <Button
              onClick={handleDelete}
              className="h-8 px-5 py-2 text-sm font-semibold bg-pink hover:bg-pink/80 rounded-md"
            >
              삭제하기
            </Button>
          </AlertDialogAction>
          <AlertDialogCancel asChild>
            <Button className="h-8 px-5 py-2 text-sm text-gray-A font-semibold bg-gray-E hover:bg-gray-E/80 rounded-md">
              취소하기
            </Button>
          </AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
